import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Button, Modal} from 'react-bootstrap';

const PopupNewForm6101 = ({
                            isOpen,
                            onHide,
                            onSubmit
                          }) => {
  return (
    <Modal show={isOpen} onHide={onHide}>
      <div className={'p-6'}>
        <Modal.Title className={'text-primary text-center'}>
          <FormattedMessage
            id="userDetails-files-generate-pdf-new"
            defaultMessage="Generate PDF"
          />
        </Modal.Title>
        <Modal.Body>
          <div className="h3 text-center">
            <FormattedMessage
              id="userDetails-files-generate-pdf-new-text"
              defaultMessage="Generate PDF"
            />
          </div>
        </Modal.Body>
        <div className={'d-flex justify-content-center'}>
          <Button
            variant="secondary"
            size="sm"
            onClick={onHide}
            className={'w-100px'}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-close"
              defaultMessage="Close"
            />
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={onSubmit}
            className={'ml-8 w-100px'}
          >
            <FormattedMessage
              id="userDetails-files-generate-pdf-generate"
              defaultMessage="Generate PDF"
            />
          </Button>
        </div>
      </div>
    </Modal>
  );
};

PopupNewForm6101.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default PopupNewForm6101;

